<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2022-04-26 16:51:41
 * @LastEditors: liang
 * @LastEditTime: 2025-05-30 18:29:58
-->
<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang

 * @LastEditTime: 2025-05-30 17:30:38
-->
<template>
  <div class="index">
    <div class="commonbox">
      <div class="banner">
        <el-carousel height="400px">
          <el-carousel-item>
            <img :src="banner" height="400" />
          </el-carousel-item>
          <!-- <el-carousel-item>
            <img :src="banner1" height="400" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="banner2" height="400" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="banner3" height="400" />
          </el-carousel-item> -->
        </el-carousel>
      </div>
    </div>
    <template v-if="isLogin&&indexbuyarr.length>0">
      <div class="commonbox">
        <div class="w1200 indexlist">
          <h3>
            单位课程
            <router-link class="more" :to="{path:'/list',query: { teachingName:'',buyDeptId:isLogin?this.user.deptId:''}}">更多</router-link>
          </h3>
          <ul>
            <li @click="todetail(data.teachingType,data.id,data.teachingName)"  v-for="data in indexbuyarr" :key="data.id">
              <div class="img">
                <img :src="data.teachingLogoUrl!=''?minioUrl+data.teachingLogoUrl:bdImg" />
              </div>
              <div class="name">
                {{data.teachingName}}
              </div>
              <div class="priceother">
                <span class="green">{{data.teachingPrice==0?'免费':data.teachingPrice}}</span>
                <span class="deptName">{{data.deptName}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <div class="commonbox" v-for="(item,index) in indexarr" :key="index">
      <div class="w1200 indexlist">
        <h3>
           <span v-if='index==0'>免费视频课程</span>
           <span v-else>{{item.typeName}}</span>
          <router-link class="more" :to="{path:'/list',query: { selectId: item.id }}">更多</router-link>
        </h3>
        <ul>
          <li @click="todetail(item.id,data.id,data.teachingName)"  v-for="(data,i) in item.trainTeachingDTOS" :key="i">
            <div class="img">
              <img :src="data.teachingLogoUrl!=''?minioUrl+data.teachingLogoUrl:bdImg" />
            </div>
            <div class="name">
              {{data.teachingName}}
            </div>
            <div class="priceother">
              <span class="green">{{data.teachingPrice==0?'免费':data.teachingPrice}}</span>
              <span class="deptName">{{data.deptName}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      indexarr: [],
      indexbuyarr: [],
      minioUrl: '',
      isLogin: false,
      token: '',
      user: {},
      banner: require('@/assets/img/banner.png'),
      banner1: require('@/assets/img/banner.jpg'),
      banner2: require('@/assets/img/banner1.jpg'),
      banner3: require('@/assets/img/banner2.jpg'),
      bdImg: require('@/assets/img/gcourse.png')
    }
  },
  created () {
    if (this.$route.query.loginjson) {
      let loginjson = JSON.parse(this.$route.query.loginjson)
      localStorage.setItem('webtoken', loginjson.token)
      Cookies.set('webtoken', loginjson.token)
      let userData = JSON.stringify(loginjson.user)
      localStorage.setItem('user', userData)
      window.location.href = '/#/index'
      this.$router.replace({ name: 'home' })
      setTimeout(() => {
        window.location.reload()
      }, 100)
    } else {
      this.isLogin = !!localStorage.getItem('webtoken')
      this.token = localStorage.getItem('webtoken')
      this.user = JSON.parse(localStorage.getItem('user')) || {}
      this.minioUrl = process.env.VUE_APP_minio
      this.getlist()
      if (this.isLogin) {
        this.getbuylist()
        this.findByDept()
      }
    }
  },
  methods: {
    findByDept () {
      this.$get('/pay/paygoodsorder/findByDept?deptId=' + this.user.deptId).then(res => {
        if (res.code === 0) {
          if (!res.data) {
            localStorage.setItem('showBtn', false)
            this.$store.state.showBtn = false
          } else {
            if (+res.data.status === 1) {
              localStorage.setItem('showBtn', true)
              this.$store.state.showBtn = true
            } else {
              localStorage.setItem('showBtn', false)
              this.$store.state.showBtn = false
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getbuylist () {
      this.$get('/client/home/getBuyCourseList?token=' + this.token + '&ssProvince=130000&ssCity=' + localStorage.getItem('citycode')).then(res => {
        if (res.code === 0) {
          this.indexbuyarr = res.data
        }
      })
    },
    getlist () {
      this.$get('/clientNotAuth/getCourseList?ssProvince=130000&ssCity=' + localStorage.getItem('citycode')).then(res => {
        if (res.code === 0) {
          this.indexarr = res.data
        }
      })
    },
    todetail (selectId, id, teachingName) {
      this.$router.push({ path: '/detail', query: { selectId: selectId, tid: id, tName: teachingName } })
    }
  }
}
</script>
<style scoped>
.banner {
  width: 100%;
  height: 400px;
}
.banner img {
  width: 100%;
  height: 100%;
}

.commonbox:nth-child(even) {
  background: #f7f7f7;
}
.commonbox:nth-child(odd) {
  background: #fff;
}
.indexlist h3 {
  position: relative;
  font-size: 24px;
  color: #333;
  font-weight: 500;
  letter-spacing: 5px;
  line-height: 36px;
  text-align: center;
  padding: 30px 0;
}
.indexlist h3 .more{position: absolute;right: 0;top: 30px;font-size: 16px;color: #666;letter-spacing: 2px;}
.indexlist h3 .more:hover{color: #409eff;}
.indexlist ul {
  overflow: hidden;
}
.indexlist ul li {
  cursor: pointer;
  position: relative;
  border-radius: 8px 8px 0 0;
  z-index: 1;
  float: left;
  width: 225px;
  margin-right: 17px;
  margin-bottom: 20px;
  /* -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear; */
  padding-bottom: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px 0 rgba(7, 17, 27, 0.1);
  background: #fff;
}
.indexlist ul li:hover .name {
  color: #f56c6c;
}
.indexlist ul li:nth-child(5n) {
  margin-right: 0;
}
.indexlist ul li .name {
  font-size: 15px;
  height: 40px;
  margin: 10px 8px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.indexlist ul li .priceother {
  display: flex;
  padding: 0 8px;
  box-sizing: border-box;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.indexlist ul li .priceother .deptName{white-space: nowrap;width: 160px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;}
.indexlist ul li > div {
  float: left;
  overflow: hidden;
}
.indexlist ul li .img {
  width: 100%;
  height: 125px;
  overflow: hidden;
}
.indexlist ul li .img img {
  width: 100%;
  height: 125px;
  transition: all 0.3s ease-out;
  float: left;
}
.indexlist ul li .img:hover img {
  float: left;
  transform: scale(1.2);
}
.titleleft {
  display: inline-block;
  height: 24px;
  width: 84px;
  background: url("~@/assets/img/tit-icon-left.png") no-repeat;
  background-size: auto 100%;
}
.titleright {
  display: inline-block;
  height: 24px;
  width: 84px;
  background: url("~@/assets/img/tit-icon-right.png") no-repeat;
  background-size: auto 100%;
}
</style>
